import { SecondBrainLayout } from './components';
import { useSecondBrainExperience } from './hooks';

const SecondBrainExperience = () => {
  const experienceState = useSecondBrainExperience();

  return <SecondBrainLayout {...experienceState} />;
};

export default SecondBrainExperience;
